const countryEnvConfig = () => {
  const data = {
    MX: {
      seo: {
        priceCurrency: 'MXN',
        name: 'TUHABI',
        urlHome: 'https://www.tuhabi.mx/',
        urlListing: 'https://www.tuhabi.mx/propiedades/',
      },
      propertyCard: {
        header: {
          priceCurrency: 'MXN',
        },
        accordion: {
          garage: 'Estacionamiento',
          rooms: 'Recamaras',
        }
      },
    },
    CO: {
      seo: {
        priceCurrency: 'COP',
        name: 'HABI',
        urlHome: 'https://www.habi.co/',
        urlListing: 'https://www.habi.co/venta-apartamentos/',
      },
      propertyCard: {
        header: {
          priceCurrency: 'COP',
        },
        accordion: {
          garage: 'Garajes',
          rooms: 'Habitaciones',
        }
      },
    },
  };

  return data[process.env.GATSBY_COUNTRY] || null;
};

export default countryEnvConfig;
